// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderProductImage_container__SvSo3","icon":"HeaderProductImage_icon__ZLv_Y"};